<template>
    <div>
        <Transition
            v-if="!requestSent"
            name="fade"
            mode="out-in"
        >
            <div
                class="Newsletter"
            >
                <PageTitle class="Newsletter-title">
                    <div>{{ $t('personal-account.newsletter.title') }}</div>
                    <div class="Newsletter-tag">
                        <Tag
                            :type="optedIn ? 'success' : 'warning'"
                        >
                            {{ $t(`personal-account.newsletter.tag.${optedIn ? 'subscribed' : 'unsubscribed'}`) }}
                        </Tag>
                    </div>
                </PageTitle>

                <div class="Newsletter-globalContainer">
                    <div class="Newsletter-container">
                        <Block>
                            <p>
                                {{ $t('personal-account.newsletter.description.1') }}
                            </p>
                            <div class=" row">
                                <div class="col-12">
                                    <InputFieldWithLabel
                                        :value="$store.state.user.email"
                                        data-cy="input.email"
                                        :label="$t('personal-account.profile.personal-info.email')"
                                        :disabled="true"
                                        :readonly="true"
                                        class="Newsletter-inputDisabled"
                                    />
                                </div>
                            </div>
                            <p class="Newsletter-highlightText">
                                {{ $t('personal-account.newsletter.description.2') }}
                            </p>
                            <div class="Newsletter-toggleContainer">
                                <div>
                                    {{ $t(`personal-account.newsletter.subscribe`) }}
                                </div>
                                <ToggleSwitch
                                    :value="optedIn"
                                    data-cy="switch.newsletter"
                                    @input="toggleSwitch"
                                />
                            </div>
                        </Block>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import Transition from "@/components/Transition.vue";
import {
    Block, InputFieldWithLabel, ToggleSwitch
} from '@free2move/vuejs-components';

import Tag from '@/components/Tag.vue';

import Vue from "vue";
import Component from "vue-class-component";
import {UNSUBSCRIBE_NEWSLETTER, SUBSCRIBE_NEWSLETTER, GET_BRAZE_STATUS} from "@/store/action-types";
import * as mutationTypes from "@/store/mutation-types";

@Component({
    components: {
        PageTitle,
        Transition,
        Block,
        InputFieldWithLabel,
        ToggleSwitch,
        Tag
    },
})
export default class Newsletter extends Vue {
    data() {
        return {
            optedIn: false,
        }
    }

    mounted() {
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_BRAZE_STATUS, {
            callback: (response) => {
                if (!response.error) {
                    this.optedIn = response.data.opted_in;
                }
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            },
        });
    }

    unsubscribeNewsletter() {
        this.$store.dispatch(UNSUBSCRIBE_NEWSLETTER, {
            callback: (response) => {
                if (!response.error) {
                    this.optedIn = !this.optedIn;
                }
            },
            data: {}
        });
    }

    subscribeNewsletter() {
        this.$store.dispatch(SUBSCRIBE_NEWSLETTER, {
            callback: (response) => {
                if (!response.error) {
                    this.optedIn = !this.optedIn;
                }
            },
            data: {}
        });
    }

    toggleSwitch() {
        if (this.optedIn) {
            this.unsubscribeNewsletter();
        } else {
            this.subscribeNewsletter();
        }
    }
}
</script>

<style lang="scss" scoped>
.Newsletter {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 56px;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-title {
        margin-bottom: 60px;
    }

    &-toggleContainer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
    }

    &-inputDisabled {
        background: #F3F2F9;
        border-radius: 10px;
    }

    &-highlightText {
        font-weight: bold;
    }

    &-tag {
        margin-top: -15px;
    }
}
</style>
